<app-header></app-header>

<!--====== PAGE TITLE PART START ======-->
<div class="banner-active">
    <div class="single-banner bg_cover" *ngFor="let slide of slideData;let index=i" 
         [ngStyle]="{'background-image': 'url('+slide.img+')', 'background-repeat': 'no-repeat'}">
        <div class="banner-overlay">
            <div class="container">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="banner-content text-center">
                            <h1 data-animation="fadeInLeft" data-delay="0.9s" class="title c-title" [innerHTML]="slide.title"></h1>
                            <span data-animation="fadeInLeft" data-delay="0.5s" class="c-sub-title">{{slide?.subTitle}}</span>
                            <div data-animation="fadeInLeft" data-delay="1.3s">
                                <span class="assurance">{{slide.type}}</span>
                                <div class="barre-bottom"></div>
                                <img class="assu-img" [src]="slide.imgIcon" alt="">
                            </div>
                            <span data-animation="fadeInUp" data-delay="1.6s" class="main-btn-title">Retraite</span>
                            <br>
                            <a class="main-btn" data-animation="fadeInUp" data-delay="1.6s" (click)="getDevisAutre()">Obtenir un devis</a>
                            <!-- <a class="main-btn" data-animation="fadeInUp" data-delay="1.6s" (click)="currentStep = 0">Obtenir un devis</a> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="case-studies-area">
  <div class="container">
    
    <!-- Barre de progression -->
    <div class="row" *ngIf="currentStep > 0 && currentStep < 4">
      <div class="devis">
        <div class="title">Ma souscription Prévoyance Retraite</div>
        <img src="assets/images/stopwatch.svg" alt="">
      </div>
      <div class="temps">
        <span class="barre-temps"></span>
        <span class="message-temps">En quelques minutes</span>
      </div>
    </div>

    <div class="latest-services-area">
      <div class="container">
        <div class="formulaire" *ngIf="currentStep >= 0">
          <form [formGroup]="souscriptionForm" class="form-wizard-container">
            
            <!-- Page d'accueil -->
            <div class="welcome-step" *ngIf="currentStep === 0">
              <div class="welcome-content">
                <h1>Bonjour ! Je suis Marilyne</h1>
                <h2>Je suis là pour vous aider</h2>
                <p class="welcome-description">
                  Obtenez votre devis de prévoyance retraite en quelques minutes seulement.
                  Je vais vous guider étape par étape pour sécuriser votre avenir financier.
                </p>
                <button class="cta-button" (click)="nextStep()">
                  C'est parti !!
                </button>
              </div>
            </div>

            <!-- Étape 1: Informations personnelles -->
            <div class="step-container" *ngIf="currentStep === 1">
              <div class="step-header">
                <h2>Informations personnelles</h2>
                <p class="step-subtitle">Vos informations personnelles</p>
                <div class="step-progress">Étape 1 sur 2</div>
              </div>

              <div class="form-grid formulaire">
                 <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box mt-30">
                  <input type="text" formControlName="nom" placeholder="Nom" noAutocomplete>
                  <i class="barre"></i>
                </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box mt-30">
                  <input type="text" formControlName="prenom" placeholder="Prénom" noAutocomplete>
                  <i class="barre"></i>
                </div>
                </div>
              </div>

              <div class="form-grid formulaire">
                <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box">
                  <input type="text" 
                         formControlName="dateNaiss"
                         bsDatepicker
                         [maxDate]="newDate"
                         [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', locale: 'fr'}"
                         placeholder="Date de naissance">
                  <span class="input-icon">
                    <img src="assets/images/icon-date.svg" alt="">
                  </span>
                </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box">
                  <input type="text" formControlName="adresse" placeholder="Adresse" noAutocomplete>
                  <i class="barre"></i>
                </div>
                </div>

              </div>

              <div class="form-grid formulaire">
                  <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box">
                    <input type="email" formControlName="email" placeholder="Courriel *" noAutocomplete>
                    <i class="barre"></i>
                  </div>
                   <div *ngIf="souscriptionForm.get('email').errors">
                      <div
                        *ngIf="souscriptionForm.get('email').errors.required && (souscriptionForm.get('email').dirty || souscriptionForm.get('email').touched)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                      <div *ngIf="souscriptionForm.get('email').errors.pattern">
                        <div class="text-red">
                          Email est invalide
                        </div>
                      </div>
                  </div>
                </div>

                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box sinistre">
                    <input type="tel" 
                          formControlName="telephone"
                          ng2TelInput 
                          [ng2TelInputOptions]="{initialCountry: currentFiliale?.code}"
                          placeholder="Numéro de téléphone *"
                          (focus)="isFocus=true" 
                          (blur)="isFocus=false; hasError($event, 'telephone', 'souscriptionForm');autoSave()"
                          (ng2TelOutput)="getNumber($event, 'telephone', 'souscriptionForm')"
                          (intlTelInputObject)="telInputObject($event)" 
                          (countryChange)="onCountryChange($event)" noAutocomplete>
                  </div>
                  <div *ngIf="souscriptionForm.get('telephone').errors">
                      <div
                        *ngIf="souscriptionForm.get('telephone').errors.required && (souscriptionForm.get('telephone').dirty || souscriptionForm.get('telephone').touched)">
                        <div class="text-red">
                          Ce champs est obligatoire
                        </div>
                      </div>
                    </div>
                </div>
              </div>

              <div class="formulaire pl-10">
                <div class="input-radio">
                  <div class="row">
                    <div class="isLabel">Souscription et prime</div>
                    <div class="col-md-6 col-sm-6 col-xs-12" *ngFor="let option of listSouscriptionPrime">
                      <input type="radio" [id]="option.value" [value]="option.value" formControlName="souscriptionPrime" />
                      <label [for]="option.value">{{option.name}}</label>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-grid formulaire">
                <div class="col-lg-6 col-sm-6 pr-0">
                <div class="input-box">
                  <input type="text" 
                         formControlName="dateMinimum"
                         bsDatepicker
                         [minDate]="newDate"
                         [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', locale: 'fr'}"
                         placeholder="Date minimum">
                  <span class="input-icon">
                    <img src="assets/images/icon-date.svg" alt="">
                  </span>
                </div>
                </div>
                <div class="col-lg-6 col-sm-6 pr-0">
                  <div class="input-box">
                                  <input type="text" 
                                        formControlName="dateMaximun"
                                        bsDatepicker
                                        [minDate]="newDate"
                                        [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', locale: 'fr'}"
                                        placeholder="Date maximum">
                                  <span class="input-icon">
                                    <img src="assets/images/icon-date.svg" alt="">
                                  </span>
                  </div>
                </div>
              </div>

              <div class="step-navigation">
                <button class="btn-back" (click)="currentStep = 0">Retour</button>
                <button class="btn-continue" 
                        [disabled]="!isCurrentStepValid()"
                        (click)="nextStep()">Continuer</button>
              </div>
            </div>

            <!-- Étape 2: Information de l'ayant-droit -->
            <div class="step-container" *ngIf="currentStep === 2">
              <div class="step-header">
                <h2>Information de l'ayant-droit</h2>
                <p class="step-subtitle">Informations sur le bénéficiaire</p>
                <div class="step-progress">Étape 2 sur 2</div>
              </div>

              <div class="form-grid formulaire">
                <div class="input-box mt-30">
                  <input type="text" formControlName="nomAyant" placeholder="Nom de l'ayant-droit">
                  <i class="barre"></i>
                </div>
                
                <div class="input-box mt-30">
                  <input type="text" formControlName="prenomAyant" placeholder="Prénom de l'ayant-droit">
                  <i class="barre"></i>
                </div>
              </div>

              <div class="form-grid formulaire">
                <div class="input-box">
                  <input type="text" 
                         formControlName="dateNaissAyant"
                         bsDatepicker
                         [maxDate]="newDate"
                         [bsConfig]="{dateInputFormat: 'DD-MM-YYYY', locale: 'fr'}"
                         placeholder="Date de naissance de l'ayant-droit">
                  <span class="input-icon">
                    <img src="assets/images/icon-date.svg" alt="">
                  </span>
                </div>

                <div class="input-box">
                  <input type="text" formControlName="adresseAyant" placeholder="Adresse de l'ayant-droit">
                  <i class="barre"></i>
                </div>
              </div>

              <div class="form-grid formulaire">
                <div class="input-box">
                  <input type="email" formControlName="emailAyant" placeholder="Courriel de l'ayant-droit">
                  <i class="barre"></i>
                </div>

                <div class="input-box sinistre">
                  <input type="tel" 
                         formControlName="telephoneAyant"
                         ng2TelInput 
                         [ng2TelInputOptions]="{initialCountry: currentFiliale?.code}"
                         placeholder="Numéro de téléphone de l'ayant-droit"
                         (focus)="isFocus=true" 
                         (blur)="isFocus=false; hasError($event, 'telephoneAyant', 'souscriptionForm')"
                         (ng2TelOutput)="getNumber($event, 'telephoneAyant', 'souscriptionForm')"
                         (intlTelInputObject)="telInputObject($event)" 
                         (countryChange)="onCountryChange($event)">
                </div>
              </div>

              <div class="step-navigation">
                <button class="btn-back" (click)="previousStep()">Retour</button>
                <button class="btn-continue" 
                        [disabled]="!isCurrentStepValid()"
                        (click)="nextStep()">Voir le récapitulatif</button>
              </div>
            </div>

            <!-- Récapitulatif -->
            <div class="step-container_2" *ngIf="currentStep === 3">
              <div class="step-header">
                <h2>Récapitulatif de votre souscription prévoyance retraite</h2>
                <p class="step-subtitle">Vérifiez vos informations avant de finaliser</p>
              </div>

              <div class="recap-form-container">
                <div class="mesImage">
                  <div class="imgLogo">
                    <img src="assets/images/logo.png" alt="Logo Inclusive Guarantee">
                  </div>
                </div>
                
                <div class="info-devis">
                  <div class="proposition">
                    <div class="pro-title">Demande de prévoyance retraite</div>
                    <div class="sub-title">{{numeroSous}}</div>
                  </div>
                  
                  <div class="row">
                    <!-- Informations personnelles -->
                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                      <div class="title-div">
                        <span>Informations personnelles</span>
                      </div>
                      <div class="contenu-div">
                        <div class="row">
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Numéro</div>
                            <div class="col-7 value">{{numeroSous}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('nom')?.value">
                            <div class="col-5 name">Nom</div>
                            <div class="col-7 value">{{souscriptionForm?.get('nom')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('prenom')?.value">
                            <div class="col-5 name">Prénom</div>
                            <div class="col-7 value">{{souscriptionForm?.get('prenom')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('dateNaiss')?.value">
                            <div class="col-5 name">Date de naissance</div>
                            <div class="col-7 value">{{souscriptionForm?.get('dateNaiss')?.value | date:'dd/MM/yyyy'}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('adresse')?.value">
                            <div class="col-5 name">Adresse</div>
                            <div class="col-7 value">{{souscriptionForm?.get('adresse')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('email')?.value">
                            <div class="col-5 name">Email</div>
                            <div class="col-7 value">{{souscriptionForm?.get('email')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('telephone')?.value">
                            <div class="col-5 name">Téléphone</div>
                            <div class="col-7 value">{{souscriptionForm?.get('telephone')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('souscriptionPrime')?.value">
                            <div class="col-5 name">Type de prime</div>
                            <div class="col-7 value">{{souscriptionForm?.get('souscriptionPrime')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('dateMinimum')?.value">
                            <div class="col-5 name">Date minimum</div>
                            <div class="col-7 value">{{souscriptionForm?.get('dateMinimum')?.value | date:'dd/MM/yyyy'}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('dateMaximun')?.value">
                            <div class="col-5 name">Date maximum</div>
                            <div class="col-7 value">{{souscriptionForm?.get('dateMaximun')?.value | date:'dd/MM/yyyy'}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                    
                    <!-- Information de l'ayant-droit -->
                    <div class="col-md-6 col-lg-6 col-sm-12 col-xs-12 c-col-6">
                      <div class="title-div">
                        <span>Information de l'ayant-droit</span>
                      </div>
                      <div class="contenu-div">
                        <div class="row">
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('nomAyant')?.value">
                            <div class="col-5 name">Nom</div>
                            <div class="col-7 value">{{souscriptionForm?.get('nomAyant')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('prenomAyant')?.value">
                            <div class="col-5 name">Prénom</div>
                            <div class="col-7 value">{{souscriptionForm?.get('prenomAyant')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('dateNaissAyant')?.value">
                            <div class="col-5 name">Date de naissance</div>
                            <div class="col-7 value">{{souscriptionForm?.get('dateNaissAyant')?.value | date:'dd/MM/yyyy'}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('adresseAyant')?.value">
                            <div class="col-5 name">Adresse</div>
                            <div class="col-7 value">{{souscriptionForm?.get('adresseAyant')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('emailAyant')?.value">
                            <div class="col-5 name">Email</div>
                            <div class="col-7 value">{{souscriptionForm?.get('emailAyant')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex" *ngIf="souscriptionForm?.get('telephoneAyant')?.value">
                            <div class="col-5 name">Téléphone</div>
                            <div class="col-7 value">{{souscriptionForm?.get('telephoneAyant')?.value}}</div>
                          </div>
                          <div class="col-12 d-flex">
                            <div class="col-5 name">Date de demande</div>
                            <div class="col-7 value">{{newDate | date:'dd/MM/yyyy'}}</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  
                  <div class="description-ass">
                    Cette demande de prévoyance retraite sera traitée par nos équipes dans les plus brefs délais. 
                    Vous recevrez une confirmation par email avec les détails de votre couverture retraite.
                  </div>
                  
                  <div class="disposition row col-md-12 col-lg-12 col-sm-12 col-xs-12">
                    <div class="title-dispo-footerL col-md-6 col-lg-6 col-sm-12 col-xs-12">
                      Demande de prévoyance retraite
                    </div>
                    <div class="title-dispo-footerR col-md-6 col-lg-6 col-sm-12 col-xs-12">
                      Date émission : {{newDate | date:'dd/MM/yyyy'}} - E-MAIL : contact&#64;inclusiveguarantee.fr
                    </div>
                  </div>
                </div>
              </div>
              
              <div class="step-navigation">
                <button class="btn-back" (click)="previousStep()">
                  Retour
                </button>
                <button type="button" class="btn-continue final-btn" [disabled]="sendingRequest" (click)="saveData()">
                  <i class="fa fa-spinner fa-pulse" *ngIf="sendingRequest"></i>
                  <span *ngIf="!sendingRequest">Finaliser la souscription</span>
                  <span *ngIf="sendingRequest">Traitement en cours...</span>
                </button>
              </div>
            </div>

            <!-- Étape de succès -->
            <div class="step-container" *ngIf="currentStep === 4">
              <div class="success-auto">
                <div class="icon-succes">
                   <img width="10%" src="/assets/images/verifier.png" alt="" srcset="">
                </div>
                <!-- <div class="message-success">
                  Votre demande de prévoyance retraite a été enregistrée avec succès !
                  <span>Numéro de référence : {{numeroSous}}</span>
                  <span>Nos équipes vous contacteront dans les plus brefs délais.</span>
                </div> -->
                <div class="message-success">
                  Votre demande a été soumise avec succès. Vous recevrez un devis sous 48h. Merci pour la confiance.
                  <span>L'équipe d'Inclusive Guarantee</span>
                </div>
                <button class="btn-success" (click)="resetForm()">
                  <span>Nouvelle demande</span>
                </button>
              </div>
            </div>

          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>